import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendLongFormBuilderOutlineSection,
  BackendMutationSwitchLongFormBuilderOutlineSectionsArgs,
} from 'src/types/backend';

const MUTATION = gql`
  mutation SwitchLongFormBuilderOutlineSections($sectionId1: ID!, $sectionId2: ID!) {
    switchLongFormBuilderOutlineSections(sectionId1: $sectionId1, sectionId2: $sectionId2) {
      id
    }
  }
`;

type Variables = BackendMutationSwitchLongFormBuilderOutlineSectionsArgs;
type Result = Pick<BackendLongFormBuilderOutlineSection, 'id'>[];

export const switchLongFormBuilderOutlineSections = async (variables: Variables) => {
  const result = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<Result>(result.data);
};
